import React from 'react';
import MenuItem from './MenuItem';



const MenuSectionContent = ({ content, activeFilters }) => {
    if (!content) return null;

    return (
        <div className="c__menu-section-content">
            {content.map((menuSectionRow, rowIndex) => (
                <React.Fragment key={rowIndex}>
                    {menuSectionRow.section_title && <h3 className="section-title | text-black text-[32px] font-bold font-mono capitalize leading-[40px] mb-3">{menuSectionRow.section_title}</h3>}
                    {menuSectionRow.section_description && <p className="section-description | text-black text-md xl:text-lg font-normal font-mono  mb-5  xl:max-w-[900px]">{menuSectionRow.section_description}</p>}
                    {menuSectionRow.section_menu_items.length > 0 && (
                        <div className="menu-items | grid xl:grid-cols-2 gap-x-16 gap-y-8 xl:max-w-[900px] mb-12  mt-5 xl:mt-8">
                            {menuSectionRow.section_menu_items.map((item, index) => (
                                <MenuItem key={index} item={item} activeFilters={activeFilters} />
                            ))}
                        </div>
                    )}
                </React.Fragment>
            ))}
            
        </div>
    );
};

export default MenuSectionContent;
